



































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { padHeadPanel3,logoutPanel,openingPrompt } from "@/components";
import { TbGoods, TbMember, TbSettingsPad, TbShop, TbShopAccount } from '@/http';
import { Dialog, Toast } from 'vant';
import calculate from '@/common/util/calculate';
import dayjs from 'dayjs';
import { fmoney } from '@/common/money';
import payPanel from './components/payPanel.vue';
import Bus from '@/common/util/bus';
import {PrintEvent2} from "@/common/util/prints";
const { userAgent } = navigator;
const isAndroid = userAgent.indexOf('Android') > -1 ||userAgent.indexOf('android') > -1 || userAgent.indexOf('Adr') > -1;; // android终端
@Component({
    components: {
        padHeadPanel3,logoutPanel,payPanel,openingPrompt
    },
})
export default class vipRecharge extends Vue {
    public $refs: {
    };
    /**提示弹窗 */
    tipShow = false;
    tipTitle ="";
    tipText="";
    confirmText="";
    cancelText="";
    btnNums=2;
    tipType=1;

    form:any={
        balance:0
    };
    id="";
    userInfo

    editForm:any={
        rechargeAmount:null,
        giftAmount:null,
        paymentMethod:2,
        cashierId:"",
        cashier:"",
        cashPart:null,
        weChatPart:null,
        alipayPart:null,
        score:null,
    }
    /**员工下拉 */
    showAccountPopover = false;
    accountOptions=[];

    /**数字键盘 */
    config={
        loop : [
            {
                number : 1,
                key : 'number-1',
            },
            {
                number : 2,
                key : 'number-2',
            },
            {
                number : 3,
                key : 'number-3',
            },
            {
                number : 4,
                key : 'number-4',
            },
            {
                number : 5,
                key : 'number-5',
            },
            {
                number : 6,
                key : 'number-6',
            },
            {
                number : 7,
                key : 'number-7',
            },
            {
                number : 8,
                key : 'number-8',
            },
            {
                number : 9,
                key : 'number-9',
            },
        ]
    }
    value = null;
    maxLength = 10;
    editNumType = 1;

    /**店铺审核信息 */
    approveInfo:any={};

    /**积分配置信息 */
    settingContent:any = {};

    isloading = false;

    /**确定充值弹窗 */
    confirmShow = false;

    /**充值成功 */
    successShow = false;
    /**充值失败 */
    failShow = false;

    fmoney = fmoney;

    isPrintLoading = false;

    printSettingContent:any={};

    payShow = false;
    orderNo = "";
    orderId = "";

    isStartPaying = false;

    isScaning = false;
    /**会员-支付弹窗是否打开 */
    isVipPaying = false;

    /**是否是会员月 */
    isBirthDay = false;
    birthOpen = false;

    /**更多支付方式 */
    hasOfflineWeChat = false;
    hasOfflineAlipay = false;

    /** 动态轮询定时器 */
    pollTimer= null;
    /** 未获取到支付结果-超时弹窗 */
    payovertimeShow= false;
    /** 用户手动取消轮询标志 */
    isPayCanceled= false;

    /**充值后金额 */
    get afterCharge(){
        let val = null;
        let a = this.form.balance?this.form.balance:0;
        let b = this.editForm.rechargeAmount?this.editForm.rechargeAmount:0;
        let c = this.editForm.giftAmount?this.editForm.giftAmount:0;
        val = calculate.addition(calculate.addition(a,b),c);
        return val;
    }
    get vipName(){
        let str = "";
        let name = this.form.name?' / '+this.form.name:'';
        str = `${this.form.phone}${name}`
        return str;
    }

    created() {
        this.id = this.$route.query.id;
        this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"))
    }
    async mounted(){
        this.init();
        this.getAccountList();
        this.getShopApproveInfo();
        this.getScoreSet();
        this.getPrintSet();
        this.getMorePaySet();
        if(this.approveInfo.approveStatus==5){
            this.editForm.paymentMethod = 4;
        }else{
            if(this.approveInfo.alipayApproveStatus==5){
                this.editForm.paymentMethod = 3;
            }else{
                this.editForm.paymentMethod = 2;
            }
        }

        this.editForm.cashier = this.userInfo.name;
        this.editForm.cashierId = this.userInfo.id;

        Bus.$on('isScaning',(val)=>{
            this.isScaning = val;
        })

        Bus.$on('isVipPaying',async (val)=>{
            this.isVipPaying = val;
        })



        Bus.$on('vipPayFalse',(val)=>{
            if(val){
                if(this.$refs['payPanel']){
                    this.$refs['payPanel'].closeFun();
                }
                this.failShow = true;
            }
         })

         document.addEventListener('click',this.chargeInputFocus)

    }
    beforeDestroy() {
        document.removeEventListener('click',this.chargeInputFocus)
        clearTimeout(this.pollTimer);
        this.pollTimer = null;
        Bus.$off('vipPayFalse');
        Bus.$off('isVipPaying');
        Bus.$off('isScaning');
    }

    async scanInput(val){
        // Toast(val)
        if(this.isScaning) return;
        if(this.isVipPaying){
            // Toast('val2')
            Bus.$emit('resultVipPayCode',val);
        }
    }

    chargeInputFocus(event){
        if (event.target.tagName.toLowerCase() != 'input') {

        }
    }

    async init(){
       let res = await TbMember.GetTbMemberById({id:this.id});
       this.form = res;
       let birthdayTime = res.birthdayTime?res.birthdayTime.split('-')[0]:'';
       let nowTime = dayjs().format('MM');
       this.isBirthDay = birthdayTime==nowTime?true:false;
    }
    /**员工下拉 */
    async getAccountList(){
        let res = await TbShopAccount.GetTbShopAccountList({
            needSubShop:false,
            shopid:this.userInfo.shopId,
            skip:0,
            count:-1
        })
        this.accountOptions = res.items;
    }
    /**店铺审核状态 */
    async getShopApproveInfo(){
        let res = await TbShop.GetTbShopApproveInfoByShopNo();
        this.approveInfo = res;
    }
    /**获取积分规则 */
    async getScoreSet(){
        let res = await TbSettingsPad.GetTbSettings({settingtype:8});
        this.settingContent = res.settingContent;
        this.birthOpen = res.settingContent.birthdayPoints.isOpen;
    }
    /**获取更多支付方式配置 */
    async getMorePaySet(){
        let res = await TbSettingsPad.GetTbSettings({settingtype:14});
        this.hasOfflineWeChat = res.settingContent.offlineWeChat.isSelect;
        this.hasOfflineAlipay = res.settingContent.offlineAlipay.isSelect;
    }
    /**获取打印配置 */
    async getPrintSet(){
        let resSetting= await TbSettingsPad.GetTbSettings({
            settingtype: 6,
        });
        this.printSettingContent = resSetting.settingContent;
    }

    /**提示弹窗 */
    async tipConfirm(){
        if(this.isloading===true) return;
        switch (this.tipType) {
            case 1:

                break;
            case 2:
            this.rechargeFun();
                break;

            default:
                break;
        }
        this.tipShow = false;
    }
    tipCancel(){
        this.tipShow = false;
    }

    changeAccountXL(item){
        this.editForm.cashier = item.name;
        this.editForm.cashierId = item.id;
        this.showAccountPopover = false;
    }

    setNumVal(val,type){
        this.value = val;
        this.editNumType = type;
    }
    del() {
		if(!this.value) return;
            let index = this.value.length;
            this.value = this.value.toString().slice(0,index-1);
            this.finishFun();
        }
	number(number) {
		// this.$emit("number", number);
		let val = this.value;
		let dotIndex = this.value?this.value.toString().indexOf('.'):-1;
		if(number=='.'&&dotIndex>-1||this.value&&this.value.toString().length==this.maxLength) return;
		this.value = this.value?this.value.toString() + number.toString():number.toString();
		if(dotIndex>-1){
			if(val.toString().slice(dotIndex+1).length>1){
				this.value = this.value.slice(0,dotIndex+3)
			}
		}else{
			this.value = this.value.slice(0,this.maxLength)
		}
		this.finishFun();
	}


	clearFun(){
            this.value = null;
            this.finishFun();
    }
    finishFun(){
        if(this.editNumType==1){
            this.editForm.rechargeAmount = this.value;
            let per = this.settingContent.rechargePoints&&this.settingContent.rechargePoints.per&&this.settingContent.rechargePoints.isOpen?this.settingContent.rechargePoints.per:0;
            let month = dayjs().format('MM');
            let memberMonth = this.form.birthdayTime? dayjs(this.form.birthdayTime).format('MM'):'';
            let score =  this.editForm.rechargeAmount&&per? Math.floor(this.editForm.rechargeAmount / per) : 0;
            if(this.settingContent.birthdayPoints.isOpen&&memberMonth==month){
                score = calculate.multiplication(this.settingContent.birthdayPoints.integral,score);
            }
            this.editForm.score = score? score : 0;
        }else{
            this.editForm.giftAmount = this.value;
        }
    }
    choosePay(val){
        this.editForm.paymentMethod = val;
    }
    confirmFun(){
        if(this.isloading) return;
        if(!this.editForm.rechargeAmount){
            Toast("请输入充值金额");
            return;
        }
        if(Number(this.editForm.rechargeAmount)==0){
            Toast("充值金额不能为0");
            return;
        }
        this.confirmShow = true;

    }
    cancelCz(){
        this.confirmShow = false;
    }
    async confirmCharge(){
        if(this.isloading) return;
        console.log('approveInfo',this.approveInfo);

        if(this.editForm.paymentMethod==4&&!this.approveInfo.shopNo){
            this.confirmShow = false;
            this.$refs['openingPrompt'].showFun();
            return;
        }
        if(this.editForm.paymentMethod==4&&this.approveInfo.alipayApproveStatus!=3){
            this.tipTitle = "操作提醒";
            this.tipText = `支付宝支付认证资料已提交，平台正在审核中，请耐心等待！`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.cancelText = ""
            this.tipType = 1;
            this.confirmShow = false;
            this.tipShow = true;
            return;
        }
        if(this.editForm.paymentMethod==3&&!this.approveInfo.shopNo){
            this.confirmShow = false;
            this.$refs['openingPrompt'].showFun();
            return;
        }
        if(this.editForm.paymentMethod==3&&this.approveInfo.approveStatus!=3){
            this.tipTitle = "操作提醒";
            this.tipText = `微信支付认证资料已提交，平台正在审核中，请耐心等待！`;
            this.btnNums=1;
            this.confirmText = "确认";
            this.cancelText = ""
            this.tipType = 1;
            this.confirmShow = false;
            this.tipShow = true;
            return;
        }
        if(this.editForm.paymentMethod==2){
            this.tipTitle = "操作提醒";
            this.tipText = `请务必确认是否已收到客户支付的现金！`;
            this.btnNums=2;
            this.confirmText = "确认收到";
            this.cancelText = "取消"
            this.tipType = 2;
            this.confirmShow = false;
            this.tipShow = true;
            return;
        }
        if(this.editForm.paymentMethod==13||this.editForm.paymentMethod==14){
            this.rechargeFun();
        }
        if(this.editForm.paymentMethod==3||this.editForm.paymentMethod==4){
            this.confirmShow = false;
            this.$nextTick(()=>{
                this.$refs['payPanel'].showFun();
                // this.startPay('6666');
                window.webkit.messageHandlers.getFocus.postMessage('getFocus');
            })
        }


    }
    async rechargeFun(){
        if(this.isloading === true) return;
        this.orderNo = "";
        this.orderId = "";
        this.isloading = true;
        try {
            let res= await TbMember.PostAddMemberTradeDetailV3(Object.assign({},this.editForm,{
                shopId:this.userInfo.shopId,
                memberId:this.form.id,
                memberName:this.form.name,
                phone:this.form.phone,
                tradeType:1,
                giftAmount:this.editForm.giftAmount?this.editForm.giftAmount:0,
                cashPart:0,
                weChatPart:0,
                alipayPart:0,
                score:this.editForm.score?this.editForm.score:0
            }))
            if(res.orderNo){
                this.orderNo = res.orderNo;
                this.orderId = res.id;
                this.isloading = false;
                this.confirmShow = false;
                this.successShow = true;
            }
        } catch (error) {
            this.isloading = false;
            this.failShow = true;
        }
    }
    async startPay(val){
        if(this.isStartPaying) return;
        this.isStartPaying = true;
        Bus.$emit('isScaning',true);
        this.orderNo = "";
        this.orderId = "";
         let resOrder;
        try {
            resOrder= await TbMember.PostAddMemberTradeDetailV3(Object.assign({},this.editForm,{
                shopId:this.userInfo.shopId,
                memberId:this.form.id,
                memberName:this.form.name,
                phone:this.form.phone,
                tradeType:1,
                giftAmount:this.editForm.giftAmount?this.editForm.giftAmount:0,
                cashPart:0,
                weChatPart:0,
                alipayPart:0,
                offlineWeChat:0,
                offlineAlipayPart:0,
                score:this.editForm.score?this.editForm.score:0
            }))

        } catch (error) {
          //TODO handle the exception
          /** 建单失败：复位状态，避免支付流程卡死 */
            if(this.$refs['payPanel']){
               this.$refs['payPanel'].closeFun();
            }
            this.failShow = true;
            this.isStartPaying = false;
            Bus.$emit('isScaning',false);
            return;
        }

        this.orderNo = resOrder.orderNo;
        this.orderId = resOrder.id;
        if(!this.orderId){
                /** 建单未返回订单id：复位状态，避免支付流程卡死 */
          		        if(this.$refs['payPanel']){
          		            this.$refs['payPanel'].closeFun();
          		        }
          		        this.failShow = true;
          		        this.isStartPaying = false;
          		        Bus.$emit('isScaning',false);
          		        return;
        }
        if(this.orderId){
            try {
                let res = await TbMember.PostMemberTradePayV3({
                    authCode:val,
                    id:this.orderId,
                    spbillCreateIp:''
                })
                // await this.printTest(this.orderInfo.id);

                if(!res.needPoll){
                  if(!res.isSuccessPay){
                      this.$refs['payPanel'].closeFun();
                      this.failShow = true;
                      this.isStartPaying = false;
                      Bus.$emit('isScaning',false);
                  }else{
                      this.$refs['payPanel'].closeFun();
                      this.successShow = true;
                      this.isStartPaying = false;
                      Bus.$emit('isScaning',false);
                  }
                }else{
                  /** 需要轮询充值订单支付状态，支付弹窗保持打开 */
                  						this.schedulePolling();
                }


            } catch (error) {
                this.$refs['payPanel'].closeFun();

                this.failShow = true;
                this.isStartPaying = false;
                Bus.$emit('isScaning',false);
            }
        }

    }
    /** 启动动态轮询：5秒后开始首次查询 */
    		schedulePolling(){
          this.isPayCanceled = false;
    			this.pollTimer = setTimeout(async () => {
    				await this.getOrderPayStatus();
    			}, 5000);
    		}
        /** 用户手动取消轮询 */
        cancelPolling(){
          this.isPayCanceled = true;
          clearTimeout(this.pollTimer);
          this.pollTimer = null;
          this.isStartPaying = false;
          Bus.$emit('isScaning',false);
        }
    		async getOrderPayStatus(){
          /** 用户已手动取消，停止查询 */
          if(this.isPayCanceled) return;
    			/** 支付弹窗已关闭（倒计时走完），停止轮询并兜底查询一次，防止支付成功但被超时覆盖 */
    			if(!this.$refs['payPanel'] || !this.$refs['payPanel'].isPaying){
    				this.pollTimer = null;
    				await this.finalPayStatusCheck();
    				return;
    			}
    			let res;
    			try {
    				res = await TbMember.GetMemberTradePayStatus({orderId:this.orderId});
    			} catch (error) {
            /** 轮询接口异常（断网/接口报错）：不中断轮询，按剩余倒计时继续重试，倒计时走完再兜底查询 */
            const count2 = this.$refs['payPanel'] ? this.$refs['payPanel'].count2 : 0;
            if(count2<=0){
              await this.finalPayStatusCheck();
            }else{
              const delay = count2 > 10 ? 10000 : 5000;
              this.pollTimer = setTimeout(async () => {
                await this.getOrderPayStatus();
              }, delay);
            }
            return;
    			}
    			/**
    			 * tradeStatus:
    			 * 0 = None，缺省值
    			 * 1 = Wait，待支付
    			 * 2 = Success，支付成功
    			 * 3 = Failed，支付失败
    			 * 4 = Closed，已关闭
    			 */
    			if(res.tradeStatus==2){
    				/** 支付成功 */
    				this.$refs['payPanel'].closeFun();
    				this.successShow = true;
    				this.isStartPaying = false;
    				Bus.$emit('isScaning',false);
    			}else if(res.tradeStatus==3||res.tradeStatus==4){
    				/** 支付失败或已关闭 */
    				// this.handlePollFail();
            this.$refs['payPanel'].closeFun();
            this.failShow = true;
            this.isStartPaying = false;
            Bus.$emit('isScaning',false);
    			}else{
    				/** 待支付/缺省：按剩余时间动态间隔继续轮询，剩余>10秒每隔10秒，剩余<=10秒每隔5秒 */
    				const count2 = this.$refs['payPanel'] ? this.$refs['payPanel'].count2 : 0;
    				if(count2<=0){
    					/** 倒计时走完仍无结果：兜底查询一次 */
    					await this.finalPayStatusCheck();
    				}else{
    					const delay = count2 > 10 ? 10000 : 5000;
    					this.pollTimer = setTimeout(async () => {
    						await this.getOrderPayStatus();
    					}, delay);
    				}
    			}
    		}
    		/** 轮询失败/超时未取到交易状态：展示"未获取到支付结果"超时弹窗 */
    		handlePollFail(){
    			clearTimeout(this.pollTimer);
    			this.pollTimer = null;
    			if(this.$refs['payPanel']){
    				this.$refs['payPanel'].closeFun();
    			}
    			this.isStartPaying = false;
    			Bus.$emit('isScaning',false);
    			this.payovertimeShow = true;
    		}
    		/** 倒计时结束后的最后一次查询，防止支付成功但被超时覆盖 */
    		async finalPayStatusCheck(){
          /** 用户已手动取消，停止查询 */
          if(this.isPayCanceled) return;
    			Toast.loading({
              message: "查询中",
              duration: 0, // toast不消失
          });
    			let res;
    			try {
    				res = await TbMember.GetMemberTradePayStatus({orderId:this.orderId});
    			} catch (error) {
    				Toast.clear();
    				this.handlePollFail();
    				return;
    			}
    			if(res.tradeStatus==2){
    				/** 支付成功 */
    				Toast.clear();
    				if(this.$refs['payPanel']){
    					this.$refs['payPanel'].closeFun();
    				}
    				this.successShow = true;
    				this.isStartPaying = false;
    				Bus.$emit('isScaning',false);
    			}else if(res.tradeStatus==3||res.tradeStatus==4){
            Toast.clear();
            this.$refs['payPanel'].closeFun();
            this.failShow = true;
            this.isStartPaying = false;
            Bus.$emit('isScaning',false);
          }else{
    				/** 确实未支付成功 */
    				Toast.clear();
    				this.handlePollFail();
    			}
    		}
    async closeSuccess(){
        this.successShow =false;
        this.$router.go(-1);
        this.printTest(this.orderNo);
    }
    showFail(){
        this.failShow =true;
    }
    closeFail(){
        // location.reload();
        this.failShow =false;
    }
    async printTest(orderNo){
        if(!this.printSettingContent.isPut) return;
        if(this.isPrintLoading) return;
        this.isPrintLoading = true;
        let result = await TbMember.GetTbMemberById({id:this.id});
        let address = localStorage.getItem('padShopInfo')?JSON.parse(localStorage.getItem('padShopInfo')).address:''
        let orderInfo = {
            //   订单Id
            id:"",
            // 订单编号
            orderNo:orderNo,
            // 店铺ID
            shopId:'',
            // 充值时间
            orderDate:dayjs(new Date()).format("YYYY-MM-DD HH:mm:ss"),
            // 会员Id
            memberId:'6666',
            // 会员姓名
            memberName:'',
            // 会员等级名称
            gradeName:'',
            // 会员手机号
            memberPhone:this.form.phone,
            // 支付方式
            // 0 = None，缺省值
            // 2 = Cash，现金
            // 3 = Wechat，微信
            // 4 = AliPay，支付宝
            paymentMethod:this.editForm.paymentMethod,
            //收款金额
            receivedAmount:Number(this.editForm.rechargeAmount),
            // 找零
            giveChange:0,
            // 收银员id
            cashierId:'',
            // 收银员
            cashierName:this.editForm.cashier,
            //充前金额
            originalAmount:this.form.balance,
            //充值金额
            rechargeAmount:Number(this.editForm.rechargeAmount),
            //赠送金额
            giftAmount:Number(this.editForm.giftAmount),
            //赠送积分
            giftIntegral:Number(this.editForm.score),
            //现有金额
            currentAmount:result.balance,
            //现有积分
            currentIntegral:result.integral,
            address:address,
        }

        let form = Object.assign({},{settingContent:this.printSettingContent},{orderInfo:orderInfo},{type:'receipt',chargeFlag:'1'})
        console.log('会员充值数据',form);
        let time = 3000*this.printSettingContent.putNum;
        let isOpen=Number(orderInfo.paymentMethod)==2?true:false;
        if(form.settingContent.putNum>0){
            for(let i =1;i<=form.settingContent.putNum;i++){
                setTimeout(()=>{
                    PrintEvent2(form,isOpen)
                },3000)
            }
        }
        setTimeout(()=>{
            this.isPrintLoading = false;
        },time)

        localStorage.setItem('failPrintForm',JSON.stringify(form));
    }

    closeFun(){
        this.payShow = false;
    }

    payFun(){

    }
    //查看异常订单详情-跳转会员报表-异常充值订单
      viewFailOrderDetail(){
        this.payovertimeShow = false;

        this.$router.push(`/pad/report/index?tag=vip&curZL=4`)
      }
      //关闭"未获取到支付结果"弹窗
      onPayovertimeClose(){
        this.payovertimeShow = false;
      }
    cancelFun(){
      clearTimeout(this.pollTimer);
      			this.pollTimer = null;
        this.$router.go(-1);
    }

}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/vip/vipRecharge.vue